import type {
  TrainingMatrixDocumentEntry,
  TrainingMatrixDocumentEntryAudit,
  TrainingMatrixPositionRow,
} from '@/entities/Training';

export interface TrainingMatrixRenderRow {
  key: string;
  positionId: number;
  positionName: string;
  documents: TrainingMatrixDocumentEntry[];
  audit: TrainingMatrixDocumentEntryAudit;
}

export function buildMatrixRows(positions: TrainingMatrixPositionRow[]): TrainingMatrixRenderRow[] {
  return positions.map((position) => ({
    key: String(position.id),
    positionId: position.id,
    positionName: position.name,
    documents: position.documents,
    audit: position.audit,
  }));
}
